import React from 'react';

export const Hierarchy: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, color }) => (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width={width || '1em'} height={height || '1em'} viewBox="0 0 50 50">
        <path fill="none" stroke={color || 'currentColor'} strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" d="M17 1h16v10H17zM19 36h12v10H19zM1 36h12v10H1zM37 36h12v10H37z"></path>
        <path fill="none" d="M0 0h50v50H0z"></path>
        <path fill="none" stroke={color || 'currentColor'} strokeLinecap="round" strokeMiterlimit="10" strokeWidth="2" d="M25 36V11M43 36V23H7v13"></path>
    </svg>
);
